(function () {
  function getNoteParam() {
    try {
      var note = new URLSearchParams(window.location.search).get('note');
      return note ? note.trim().toLowerCase() : '';
    } catch (e) {
      return '';
    }
  }

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function noteMatches(productNotes, needle) {
    if (!needle || !productNotes || !productNotes.length) return false;
    return productNotes.some(function (slug) {
      if (!slug) return false;
      var s = String(slug).toLowerCase();
      return s === needle || s.indexOf(needle) !== -1 || needle.indexOf(s) !== -1;
    });
  }

  function interpolate(template, vars) {
    var out = template || '';
    Object.keys(vars).forEach(function (key) {
      out = out.split('{{ ' + key + ' }}').join(vars[key]);
    });
    return out;
  }

  function labelForNote(slug, labels) {
    if (!slug) return '';
    var key = String(slug).toLowerCase();
    if (labels[key]) return labels[key];
    var matchKey = Object.keys(labels).find(function (k) {
      return k === key || k.indexOf(key) !== -1 || key.indexOf(k) !== -1;
    });
    if (matchKey) return labels[matchKey];
    return key.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function boot() {
    var root = document.querySelector('[data-lp-note-root]');
    if (!root) return;

    var note = getNoteParam();
    var labels = readJson('lp-notes-labels');
    var items = root.querySelectorAll('[data-lp-notes]');
    var empty = root.querySelector('[data-lp-note-empty]');
    var grid = root.querySelector('[data-lp-note-grid]');

    if (!note) {
      if (grid) grid.hidden = true;
      if (empty) empty.hidden = true;
      return;
    }

    if (grid) grid.hidden = false;

    var label = labelForNote(note, labels);
    var shown = 0;

    items.forEach(function (el) {
      var notes;
      try {
        notes = JSON.parse(el.getAttribute('data-lp-notes') || '[]');
      } catch (e) {
        notes = [];
      }
      var match = noteMatches(notes, note);
      el.hidden = !match;
      if (match) shown += 1;
    });

    var heading = document.querySelector('#shopify-section-heading .hdt-collection-heading, .hdt-heading-template .hdt-collection-heading');
    if (heading && root.dataset.filteredHeading) {
      heading.textContent = interpolate(root.dataset.filteredHeading, { note: label });
    }

    var lead = document.querySelector('#shopify-section-heading .hdt-collection-description, .hdt-heading-template .hdt-collection-description');
    if (lead && root.dataset.filteredLead) {
      lead.textContent = root.dataset.filteredLead;
    }

    if (empty) {
      empty.hidden = shown > 0;
      if (!shown && root.dataset.noMatches) {
        var msg = empty.querySelector('[data-lp-note-empty-msg]');
        if (msg) msg.textContent = interpolate(root.dataset.noMatches, { note: label });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
